export default __webpack_public_path__ + "static/media/underwriterIcon.ced5c741.svg";